import * as React from 'react';
import {Component, ReactNode} from 'react';
import * as PropTypes from "prop-types"

// import main styles
import "../styles/main.css";

interface LayoutProps {
    children: ReactNode
}

class Layout extends Component<LayoutProps, void> {
    render() {
        return (
            <div>
                {this.props.children()}
            </div>
        );
    }
}
//const Layout = ({ children }) => <div>{children()}</div>;

// Layout.propTypes = {
//     children: PropTypes.any,
// }

export default Layout;


// WEBPACK FOOTER //
// ./src/layouts/index.tsx